import { render, staticRenderFns } from "./PluginEdit.vue?vue&type=template&id=52024ba0"
import script from "./PluginEdit.vue?vue&type=script&lang=ts"
export * from "./PluginEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports